/**
@format
@flow
*/
import React from 'react';
import styled from 'styled-components';
import { Heading } from '@ziynx/components/typography';
import { ContentContainer } from '@ziynx/components/layout';

const PageWrapper = styled.div`
  padding: 40px;
`;

const PageNotFound = (): React$Node => (
  <ContentContainer>
    <PageWrapper>
      <Heading medium>Page Not Found</Heading>

    </PageWrapper>

  </ContentContainer>
);

export default PageNotFound;
